import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { SearchByVinViewModel } from '../../ViewModels/TowLocateViewModels/SerchbyVinViewModel';

@Injectable()
export class TowLocateSubjectService {

  private messageSource = new BehaviorSubject(new SearchByVinViewModel);
  currentMessage = this.messageSource.asObservable();

  constructor() { }

  changeMessage(message:SearchByVinViewModel)
{
  this.messageSource.next(message);
}


}



// WEBPACK FOOTER //
// ./src/app/services/TowLocateServices/tow-locate-subject.service.ts